// Currency formatting utilities

import type { Currency, Region } from '@court-sync/shared';

export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  USD: '$',
  AUD: 'A$',
  GBP: '£',
  EUR: '€',
};

export const CURRENCY_CODES: Record<Currency, string> = {
  USD: 'USD',
  AUD: 'AUD',
  GBP: 'GBP',
  EUR: 'EUR',
};

export const REGION_TO_CURRENCY: Record<Region, Currency> = {
  US: 'USD',
  AU: 'AUD',
  GB: 'GBP',
  EU: 'EUR',
};

export type { Currency, Region };

/**
 * Format price with currency symbol
 */
export function formatCurrency(amount: number, currency: Currency | string = 'AUD'): string {
  const code = (typeof currency === 'string' ? currency.toUpperCase() : currency) as Currency;
  const symbol = CURRENCY_SYMBOLS[code] ?? CURRENCY_SYMBOLS.AUD;
  return `${symbol}${amount.toFixed(2)}`;
}

/**
 * Get currency from region
 */
export function getCurrencyFromRegion(region?: Region): Currency {
  if (!region) return 'AUD'; // Default to AUD
  return REGION_TO_CURRENCY[region];
}

/**
 * Get currency symbol
 */
export function getCurrencySymbol(currency?: Currency): string {
  if (!currency) return CURRENCY_SYMBOLS.AUD;
  return CURRENCY_SYMBOLS[currency];
}

